import VerificationTemplateHeader, {
  PendingStates,
  StatusBanner,
} from 'dashboard/apps/VerificationTemplateEditor/VerificationTemplateHeader/VerificationTemplateHeader';

export default VerificationTemplateHeader;
export type { PendingStates };
export { StatusBanner };

export function getPendingStatesTitle(pendingStates: PendingStates): string | undefined {
  const { isDiscarding, isLoading, isPublishing, isUpdating } = pendingStates;
  if (isPublishing) {
    return 'Publishing...';
  }
  if (isDiscarding) {
    return 'Discarding...';
  }
  if (isUpdating) {
    return 'Saving...';
  }
  if (isLoading) {
    return 'Loading...';
  }
}
